import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import type { ReactNode } from 'react';

interface CloseButtonProps {
  onClick: () => void;
  label: ReactNode;
}

export function CloseButton({ label, onClick }: CloseButtonProps) {
  return (
    <Box sx={{ pb: 4, pt: 1, textAlign: 'center' }}>
      <Button
        onClick={onClick}
        startIcon={<CloseIcon />}
        sx={{ borderColor: 'white', color: 'white' }}
        variant="outlined"
      >
        {label}
      </Button>
    </Box>
  );
}
